import axios from 'axios'
// import md5 from 'js-md5'
import store from '../store/store'
import config from './config'
import utils from '../assets/js/utils'
import { getToken } from "@/utils/auth";
axios.defaults.timeout = config.timeout
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=utf-8'

let BASE_API = config.baseURL
// let src = config.src
// let timestamp = new Date().getTime()
// let md5Str = md5(src + timestamp + 'wef@234afw12fese')

// 请求拦截器
axios.interceptors.request.use(
  config => {
  // 是否需要设置 token
  const isToken = (config.headers || {}).isToken === false;
  if (getToken() && !isToken) {
    config.headers['token'] = getToken()||''; // 让每个请求携带自定义token 请根据实际情况自行修改
  }
    // config.header && Object.assign(config.headers, config.header)
    // config.headers['Authorization'] = store.state.user.basicParams.token || ''
    // console.log('请求',config)
    return config
  },
  error => {
    // console.log('请求拦截错误', error)
    return Promise.error(error)
  }
)

// 响应拦截器
axios.interceptors.response.use(

  // 请求成功
  res => {
     return res.status === 200 ? Promise.resolve(res) : Promise.reject(res)
  },

  // 服务器状态码不是200的情况
  error => {
    if(error.response && error.response.status){
      switch (error.response.status) {
        case 404:
          utils.toastError('请求的资源不存在')
          break
        case 408:
          utils.toastError('请求超时，请稍后再试！')
          break
        case 500:
          utils.toastError('服务器正在维护，请稍后再试！')
          break
        default:
          utils.toastError(error.response.status)
      }

      return Promise.reject(error.response)
    } else {
      let { message } = error;
      if ( message == "Network Error" ) {
        return  utils.toastError('网络异常，请检查网络状态，若无法解决请联系管理员')

      }else if(message.includes("timeout")){
        return  utils.toastError('系统接口请求超时')

      }else if(message.includes("Request failed with status code")){
        return  message = "系统接口" + message.substr(message.length - 3) + "异常";

      }
      utils.toastError('网络出了点问题，请稍后重试！')
      return Promise.reject(error)
    }
  }
)

// function isValid (status) {
//   if(status>300&&status<500){
//     window.sessionStorage.clear()
//     let url = store.state.user.basicParams.localDomain ? store.state.user.basicParams.localDomain :''
//     if(url){
//       window.location.href = url
//     }
//   }

  // const u = navigator.userAgent
  // const isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
  // const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
  // if(isAndroid) {  //android终端
  //   window.open(url);
  // }else if(isiOS) {   //ios终端
  //   window.location.href = url
  // }else { //其他端
  //   window.open(url);
  // }
// }
// function setUrls(baseUrls, dataUrl, data) {
//   let environment = process.env.NODE_ENV
//   if (data.isForeign) {
//     if (environment == 'development') {
//       let externalUrl = dataUrl.replace('https', 'http')
//       return externalUrl
//     } else {
//       return dataUrl
//     }
//   } else {
//     return baseUrls + dataUrl
//   }
// }
export default {
  getRequest(data = {}, loading) {
    loading && utils.loading()
    let params = data.msg
    return new Promise((resolve, reject) => {
      axios.get(BASE_API + data.url, { params }, data).then(res => {
        loading && utils.loaded()
        let code = res.data.code || 200
        if (code == 200) {
          resolve(res.data)
          data.success && data.success(res.data)
        }else if(code == 401){
          utils.toastNone("登录状态已过期，将跳转到登录页，重新登录！")
          window.localStorage.clear()
          window.sessionStorage.clear()
          if(window.location.pathname=='/login'){
            return
          }else {
            location.href = "/login"
          }
        } else {
          resolve(res.data)
          data.fail && data.fail(res.data)
          if (!data.special) {
            utils.toastNone(res.data.msg|| res.data.code)
          }
        }
      }).catch(error => {
        loading && setTimeout(() => {
          utils.loaded()
        }, 2000)
        // let state = error&&error.status ? error.status : ''
        // isValid(state)
        reject(error)
      })
    })
  },
  postRequest(data = {}, loading) {
    loading && utils.loading()
    let params = data.msg
    return new Promise((resolve, reject) => {
      axios.post(BASE_API + data.url , params, data).then(res => {
        loading && utils.loaded()
        if (res) {
          let code = res.data.code || 200
          switch (code) {
            case 200:
              if(data.blob){
                resolve(res)
              } else {
                resolve(res.data)
              }
              data.success && data.success(res.data)
              break
            case 401:
              utils.toastNone("登录状态已过期，将跳转到登录页，重新登录！")
              window.localStorage.clear()
              window.sessionStorage.clear()
              location.href = "/login"
              break
            // case 1:
            //   reject(res.data.desc)
            //   utils.toastNone(res.data.desc)
            //   break
            // case 10000:
            //   reject(res.data.desc)
            //   utils.toastNone(res.data.desc)
            //   break
            default:
              if (!data.special) {
                utils.toastNone(res.data.msg|| res.data.code)
              }
              resolve(res.data)
            // utils.toastNone(res.data.desc)
          }
        }
      }).catch((error) => {
        loading && setTimeout(() => {
          utils.loaded()
        }, 2000)
        // let state = error&&error.status ? error.status : ''
        // isValid(state)
        reject(error)
      })
    })
  }
}
